<template>
<div>
    <vx-card :title="title">
        <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full">
                <span>Materia</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
                <vs-input class="w-full" v-model="materia" disabled />
            </div>
        </div>
        <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full">
                <span>Grado</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
                <vs-input class="w-full" v-model="grado" disabled />
            </div>
        </div>
        <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full">
                <span>Paralelo</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
                <v-select :options="arregloParalelos" :reduce="arregloParalelos => arregloParalelos" label="" class="w-full" v-model="paralelo" />
            </div>
        </div>
        <div class="vx-row">
            <div class="vx-col sm:w-2/3 w-full ml-auto">
                <vs-button class="mr-3 mb-2" @click="enviar">Enviar</vs-button>
                <vs-button color="danger" type="border" @click="$emit('changeReturn',true)" class="mb-2">Cancelar</vs-button>
            </div>
        </div>
    </vx-card>
</div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css';
import 'flatpickr/dist/flatpickr.css';
Vue.use(axios)
export default {
    data() {
        return {
            materia: '',
            grado: '',
            usuario: [],
            idcurso: '',
            title: '',
            paralelo: '',
            arregloParalelos: [
                'A', 'B', 'C', 'D', 'E','F','OTRO'
            ],
        }
    },
    created() {
        let me = this;
        this.usuario = JSON.parse(localStorage.getItem('usuario'))[0];
        if (me.id == 0) {
            this.title = "Agregar nuevo curso"
            me.materia = localStorage.nombreasignatura
            me.grado = localStorage.yearBook
        } else {
            this.title = "Editar Curso"
            this.$http.get(this.$server_url + 'cursos/' + me.id)
                .then(function (response) {
                    me.idcurso = response.data.idcurso
                    me.materia = response.data.materia
                    me.grado = response.data.grado
                    me.paralelo = response.data.paralelo
                })
                .catch(() => {})
        }
    },
    mounted() {},
    components: {
        'v-select': vSelect
    },
    props: {
        id: {
            type: Number,
            defaut: 0
        },
    },
    methods: {
        enviar() {
            let me = this;
            console.log('paralelo',me.paralelo)
            if(me.paralelo== ''){
                me.$vs.notify({
                        text: 'Seleccione un paralelo',
                        color: 'danger',
                        iconPack: 'feather',
                        icon: 'icon-alert-triangle'
                    })
                    return
            }
            let formData = new FormData();
            formData.append("idusuario", me.usuario.idusuario);
            formData.append("idcurso", me.idcurso);
            formData.append("materia", me.materia);
            formData.append("grado", me.grado);
            formData.append('paralelo', me.paralelo)
            formData.append("id_asignatura", localStorage.idlibro);
            formData.append('periodo_id', localStorage.periodo_id)
            this.$http.post(this.$server_url + 'cursos', formData)
                .then(() => {
                    me.$vs.notify({
                        text: 'Se guardo correctamente',
                        color: 'success',
                        iconPack: 'feather',
                        icon: 'icon-alert-triangle'
                    })
                    me.$emit('changeRecharge', true)
                })
                .catch(() => {})
        },
    },
}
</script>
